import Icon from '@components/v2/ui/Icon/Icon';
import { Chip as MuiChip, ChipProps as MuiChipProps, chipClasses } from '@mui/material';
import { X } from 'lucide-react';
import { forwardRef } from 'react';

type Props = Pick<
  MuiChipProps,
  | 'label'
  | 'disabled'
  | 'onDelete'
  | 'onClick'
  | 'icon'
  | 'deleteIcon'
  | 'sx'
  | 'className'
  | 'slotProps'
  | 'title'
  | 'component'
> & {
  color?: 'default' | 'secondary';
  clickable?: boolean;
  size?: 'extraSmall' | 'small' | 'medium';
  testId?: string;
};

const Chip = forwardRef<HTMLDivElement, Props>(
  (
    {
      label,
      color,
      size,
      disabled,
      onDelete,
      onClick,
      icon,
      deleteIcon,
      sx,
      className,
      testId,
      slotProps,
      title,
      component,
      clickable = false,
    },
    ref,
  ) => {
    return (
      <MuiChip
        label={label}
        color={color}
        size={size}
        disabled={disabled}
        title={title}
        onDelete={onDelete}
        onClick={onClick}
        icon={icon}
        deleteIcon={deleteIcon ?? <Icon icon={X} size="sm" />}
        sx={sx}
        className={
          clickable ? [className, chipClasses.clickable].filter(Boolean).join(' ') : className
        }
        test-id={testId}
        ref={ref}
        slotProps={slotProps}
        component={component || 'div'}
      />
    );
  },
);

Chip.displayName = 'Chip';
export type { Props as ChipProps };
export default Chip;
